import React from "react";
import { Link } from "react-router-dom";

const ProgressBar = ({ typeofactive }) => {
  const shownavigationthroughtopbar = JSON.parse(
    sessionStorage.getItem("shownavigationthroughtopbar")
  );
  const userexists = JSON.parse(sessionStorage.getItem("userexists"));
  return (
    <div>
      <ul className="progressbar">
        <li className={typeofactive === "Customer" ? "active" : null}>
          {shownavigationthroughtopbar ? (
            <Link to="/registration/customer-information">
              Customer Information
            </Link>
          ) : (
            "Customer Information"
          )}
        </li>
        <li className={typeofactive === "Activation" ? "active" : null}>
          {!shownavigationthroughtopbar ? (
            "Activation Type"
          ) : (
            <>
              {userexists ||
              JSON.parse(sessionStorage.getItem("movetoactivationpage")) ? (
                <Link to="/registration/activation-type">Activation Type</Link>
              ) : (
                <>
                  {typeofactive === "Customer" ? (
                    <button
                      className="btn"
                      type={typeofactive === "Customer" ? "submit" : null}
                    >
                      Activation Type
                    </button>
                  ) : (
                    "Activation Type"
                  )}
                </>
              )}
            </>
          )}
        </li>
        <li className={typeofactive === "Payment" ? "active" : null}>
          {typeofactive === "Activation" ? (
            <button
              className="btn"
              type={typeofactive === "Activation" ? "submit" : null}
            >
              Payment Method
            </button>
          ) : (
            <>
              {JSON.parse(sessionStorage.getItem("movetopaymentpage")) ? (
                <Link to="/registration/payment-method">Payment Method</Link>
              ) : (
                "Payment Method"
              )}
            </>
          )}
        </li>
        <li className={typeofactive === "Terms" ? "active" : null}>
          {typeofactive === "Payment" ? (
            <button
              className="btn"
              type={typeofactive === "Payment" ? "submit" : null}
            >
              Terms of Service
            </button>
          ) : (
            <>
              {JSON.parse(sessionStorage.getItem("movetotermspage")) ? (
                <Link to="/registration/terms">Terms of Service</Link>
              ) : (
                "Terms of Service"
              )}
            </>
          )}
        </li>
        <li className={typeofactive === "Confirm" ? "active" : null}>
          Activation Confirm
        </li>
      </ul>
    </div>
  );
};

export default ProgressBar;
